export default __webpack_public_path__ + "static/media/backgroundSport.d531b485.png";